/**
 * 원화 금액을 한국어 형식으로 포맷팅
 */
export function formatKRW(amount: number): string {
  return new Intl.NumberFormat('ko-KR', {
    style: 'currency',
    currency: 'KRW',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * 원화 금액을 간단한 형식으로 포맷팅 (예: 15,000원)
 */
export function formatKRWSimple(amount: number): string {
  return `${amount.toLocaleString('ko-KR')}원`;
}

/**
 * 태그 색상 매핑
 */
export const tagColorMap: Record<string, string> = {
  '제철': 'bg-primary/10 text-primary border-primary/20',
  '신선': 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800',
  '유기농': 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800',
  '할인': 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800',
  '인기': 'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/20 dark:text-orange-400 dark:border-orange-800',
  '특가': 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-400 dark:border-yellow-800',
  '추천': 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800',
  '농가직송': 'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900/20 dark:text-purple-400 dark:border-purple-800',
};

/**
 * 태그에 따른 적절한 색상 클래스를 반환
 */
export function getTagColor(tag: string): string {
  return tagColorMap[tag] || 'bg-muted text-muted-foreground border-muted-foreground/20';
}

/**
 * 평점을 별 아이콘으로 변환
 */
export function formatRating(rating: number): string {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  
  return '★'.repeat(fullStars) + 
         (hasHalfStar ? '☆' : '') + 
         '☆'.repeat(emptyStars);
}

/**
 * 리뷰 수를 간단한 형식으로 포맷팅
 */
export function formatReviewCount(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return count.toString();
}